<template>
  <div class="section section-padding mt-n10 package-page-padding">
    <div class="container text-center">
      <div class="form-wrapper w-50">
        <img src="fingerprint.png" width="64" height="64" class="mb-5">
        <div v-if="section == 'forgot'">
          <h2>Forgot Password?</h2>
          <h5>No worries we'll send you reset instructions.</h5>
          <form @submit.prevent="send_email">
            <div class="single-form">
              <input type="email" v-model="email" required autocomplete="off" placeholder="Enter email">
            </div>
            <div class="single-form">
              <button type="submit" class="btn btn-primary btn-hover-dark w-100">
                <span>Send Code</span>
                <div v-if='loader' class="loader"></div>
                <i v-else class="flaticon-right"></i>
              </button>
            </div>
            <div class="single-form" v-if='message'>
              {{message}}
            </div>
          </form>
        </div>
        <div v-if="section == 'code'">
          <h2>Password Reset</h2>
          <h5>We have sent a code to <span class="text-bold">{{email}}</span>.</h5>
          <form @submit.prevent="submit_code">
            <div class="code-container">
              <input
                v-for="(digit, index) in digits"
                :key="index"
                v-model="digits[index]"
                maxlength="1"
                class="code-input"
                @input="onInput(index, $event)"
                @keydown.backspace="onBackspace(index, $event)"
                ref="codeInputs"
              />
              <button type="submit" class="btn btn-primary btn-hover-dark w-100" >
                <span>Continue</span>
                <div v-if='loader' class="loader"></div>
                <i v-else class="flaticon-right"></i>
              </button>
            </div>
            <div class="single-form" v-if='message'>
              {{message}}
            </div>
          </form>
        </div>
        <div v-if="section == 'reset'">
          <h2>Set New Password</h2>
          <h5>Please use a strong password</h5>
          <form @submit.prevent="reset_password">
            <div class="single-form password-field">
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                required
                autocomplete="off"
                placeholder="Password"
              >
              <button type="button" class="toggle-btn" @click="showPassword = !showPassword">
                {{ showPassword ? "🔒" : "👁️" }}
              </button>
            </div>
            <div class="single-form password-field">
              <input
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="confirm_password"
                required
                autocomplete="off"
                placeholder="Confirm Password"
              >
              <button type="button" class="toggle-btn" @click="showConfirmPassword = !showConfirmPassword">
                {{ showConfirmPassword ? "🔒" : "👁️" }}
              </button>
            </div>
            <div class="single-form">
              <button type="submit" class="btn btn-primary btn-hover-dark w-100">
                <span>Reset</span>
                <div v-if='loader' class="loader"></div>
                <i v-else class="flaticon-right"></i>
              </button>
            </div>
            <div class="single-form" v-if='message'>
              {{message}}
            </div>
          </form>
        </div>
        <div v-if="section == 'done'">
          <h2>All Done</h2>
          <h5>Your password has been reset.</h5>
          <button class="btn btn-primary btn-hover-dark w-100" @click='gotologin'>Go to Login</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api';
export default{
  name: 'ForgotPassword',
  data(){
    return{
      email: null,
      loader: false,
      message: null,
      section: 'forgot',
      digits: ['', '', '', ''],
      code: null,
      password: null,
      confirm_password: null,
      showPassword: false,
      showConfirmPassword: false
    }
  },
  methods:{
    gotologin(){
      this.$router.push('/login');
    },
    onInput(index, event) {
      const value = event.target.value;
      if (value.length === 1 && index < 3) {
        this.$refs.codeInputs[index + 1].focus();
      }
    },
    onBackspace(index) {
      if (this.digits[index] === '' && index > 0) {
        this.$refs.codeInputs[index - 1].focus();
      }
    },
    async submit_code() {
      this.code = this.digits.join('');
      if (this.code.length < 4) {
        this.message = 'Please enter all 4 digits.';
        return;
      }
      this.loader = true;
      try{
        let res = await api.post(`/user/verify-reset-code`, {'email': this.email, 'code': this.code} , {
             requiresAuth: false
        });
        if(res.data.message == 'Code verified'){
          this.message = null;
          this.digits = ['', '', '', ''];
          this.section = 'reset';
        }
      }catch (error) {
        console.log(error);
        this.message = error.response.data.message;
      }finally{
        this.loader = false;
      }
      
    },


    async reset_password(){
      if(this.password === this.confirm_password){
          this.loader = true;
          try{
            let res = await api.post(`/user/reset-password`, {'email': this.email, 'code': this.code, 'newPassword': this.password} , {
                 requiresAuth: false
            });
            if(res.data.message == 'Password reset successful'){
              this.message = null;
              this.section = 'done';
            }
          }catch (error) {
            console.log(error);
            this.message = error.response.data.message;
          }finally{
            this.loader = false;
          }
      }else{
        this.message == 'Passwords do not match!';
        return;
      }
    },

    async send_email(){
        this.loader = true;
        try{
          let res = await api.post(`/user/forgot-password`, {'email': this.email} , {
               requiresAuth: false
          });
          if(res.data.message == 'Reset code sent'){
            this.message = null;
            this.section = 'code';
          }
        }catch (error) {
          console.log(error);
          this.message = error.response.data.message;
        }finally{
          this.loader = false;
        }
    }
  } 

};
</script>
<style scoped>
button .loader {
  display: inline-block;
  margin-left: 8px; /* optional spacing between span and loader */
  vertical-align: middle;
}


.loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid white;
  border-right-color: #309255;
  animation: l2 1s infinite linear;
}
@keyframes l2 {to{transform: rotate(1turn)}}

.code-container {
  align-items: center;
  gap: 16px;
}

.code-input {
  width: 50px;
  height: 60px;
  font-size: 24px;
  text-align: center;
  margin: 10px 4px;
  border: 1px solid rgba(48, 146, 85, 0.2);
  border-radius: 10px;
  outline: none;
  transition: border-color 0.2s;
}

.code-input:focus {
  border-color: #309255;
}

.password-field {
  position: relative;
}

.password-field input {
  width: 100%;
  padding-right: 40px;
}

.toggle-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

</style>